import ReactDOM from "react-dom";
import React, { useEffect, useRef, useState } from 'react';
import langData from '../locales/langData.json';
import vid from '../assets/images/video-thum.webp';
import ProductFeature from '../components/ProductFeature';
import centerBox from '../assets/images/web-plat.webp';
import centerBoxMob from '../assets/images/mob-center-icon.svg';
import arrow from '../assets/images/right-arrow.webp';
import Faq from '../components/Faq';
import playicon from '../assets/images/play-icon.webp';
import DemoForm from '../components/Forms/DemoForm';
import SEO from '../components/SEO';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import ClientLogoMarquee from '../components/ClientLogoMarquee';

// ✅ CountUp Component
const CountUp = ({ end, duration, trigger }) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
        if (!trigger) return;
        let start = 0;
        const incrementTime = 10;
        const totalSteps = (duration * 1000) / incrementTime;
        const increment = end / totalSteps;

        const timer = setInterval(() => {
            start += increment;
            if (start >= end) {
                clearInterval(timer);
                setCount(end);
            } else {
                setCount(Math.floor(start));
            }
        }, incrementTime);

        return () => clearInterval(timer);
    }, [end, duration, trigger]);

    return <>{count}</>;
};

const Academy = ({ language = "en" }) => {
    const academy = langData[language].academy;
    const product = langData[language].products;
    const clientlogos = langData[language].clientlogo;
    const imgRef = useRef(null);
    const counterRef = useRef(null);

    const [showModal, setShowModal] = useState(false);
    const [visible, setVisible] = useState(false);

  
    // ✅ Scroll fade-in animation
    useEffect(() => {
        const handleScroll = () => {
            const element = imgRef.current;
            if (!element) return;

            const rect = element.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            const progress = 1 - rect.top / windowHeight;
            const clamped = Math.min(Math.max(progress, 0), 1);

            element.style.opacity = 1;
            element.style.transform = `translateY(${180 - clamped * 160}px)`;
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll();
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    // ✅ IntersectionObserver for CountUp
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) setVisible(true);
            },
            { threshold: 0.3 }
        );

        if (counterRef.current) observer.observe(counterRef.current);
        return () => observer.disconnect();
    }, []);

    return (
        <>
            <SEO
                title="CaptainX Academy | Sports Academy Management Solution"
                titleAr="أكاديمية كابتن اكس | حلول إدارة الأكاديمية الرياضية"
                description="Streamline academy operations, training plans, athlete development, performance tracking, and parent communication to boost efficiency by 83%."
                descriptionAr="تبسيط عمليات الأكاديمية، وخطط التدريب، وتطوير الرياضيين، وتتبع الأداء، والتواصل مع أولياء الأمور."
                path="/products/academy"
                language={language}
            />
            {showModal &&
                ReactDOM.createPortal(
                   <DemoForm
  language={language}
  onClose={() => setShowModal(false)}
/>,

                    document.body
                )
            }


            {/* HERO SECTION */}
            <div className="indual-product-section">
                <div className="m-indu-first">
                    <div className="container">
                        <center>
                            <div className="indual-hero-m">
                                <div className="cen-sec-con">
                                    <h6 className='sec-top-titl block-view mt-3'>{academy.secTopTitle}</h6>
                                    <h2
                                        className='sec-title block-view'
                                        dangerouslySetInnerHTML={{ __html: academy.title }}
                                    />
                                    <p className='block-view sec-p' dangerouslySetInnerHTML={{ __html: academy.desc }}></p>

                                    {/* ✅ Hero Button */}
                                    <div className="mob-btn">
                                      
                                         <button
                            className={`explore-btn cta-btn my-4 py-2 gap-3 block-view ${language === "ar" ? "ar-padding" : "en-padding"
                                } `}
                                            onClick={() => window.open("https://academy.captainx.ai/", "_blank")}
                        >
                            {academy.btn}
                            <LazyLoadImage src={arrow} alt="arrow" className="rt-btn" />
                        </button>
                                    </div>
                                </div>
                            </div>
                        </center>

                        <div className="ind-img-over scroll-fade-scroll" ref={imgRef}>
                            <LazyLoadImage src={vid} alt="video-thumb" className="scroll-fade-scroll" />
                            <div className="play-icon">
                                <LazyLoadImage src={playicon} alt="play-icon" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* LOGO MARQUEE */}
            <center>
                <h5 className="second-cen-text pt-3">{product.morequee}</h5>
                <ClientLogoMarquee logos={clientlogos} language={language} />
            </center>

            {/* FUTURE COUNTER SECTION */}
            <section className='future-sec'>
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-md-6" ref={counterRef}>
                            <h2
                                className="sec-title futer-title block-view"
                                dangerouslySetInnerHTML={{ __html: academy.futureTitle }}
                            />
                            <p className="sec-p futer-p block-view">{academy.futureDesc}</p>
                        </div>

                        <div className="col-md-2"></div>

                        <div className="col-md-4">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="num-card-box">
                                        <div className="number-count">
                                            <CountUp end={academy.num1} duration={2} trigger={visible} />
                                            <span>{academy.numspan}</span>
                                        </div>
                                        <div className="number-desc">{academy.num1Desc}</div>
                                    </div>
                                </div>

                                <div className="col-6">
                                    <div className="num-card-box num-box-2">
                                        <div className="number-count-two">
                                            <CountUp end={academy.num2} duration={2} trigger={visible} />
                                            <span>{academy.numspan}</span>
                                        </div>
                                        <div className="number-desc">{academy.num2Desc}</div>
                                    </div>
                                </div>

                                <div className="col-6">
                                    <div className="num-card-box num-box-2">
                                        <div className="number-count-two">
                                            <CountUp end={academy.num3} duration={2} trigger={visible} />
                                            <span>{academy.numspan}</span>
                                        </div>
                                        <div className="number-desc">{academy.num3Desc}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* PRODUCT FEATURE */}
            <ProductFeature language={language} />

            {/* PLATFORM SECTION */}
            <section className='platform'>
                <div className="container">
                    <center>
                        <h2 className='sec-title'>{academy.platformTitle}</h2>
                    </center>

                    <div className="row justify-content-center align-items-center mt-5">
                        <div className="col-md-4 d-block d-md-none mb-4">
                            <center>
                                <LazyLoadImage src={centerBoxMob} alt="center-box" className='img-fluid d-block d-md-none' />
                                <LazyLoadImage src={centerBox} alt="center-box" className='img-fluid d-none d-md-block' />
                            </center>
                        </div>

                        <div className="col-md-4">
                            <div className="card-wrap mb-4">
                                {[1, 2].map(i => (
                                    <div key={i} className="icon-box">
                                        <div className="icon">
                                            <LazyLoadImage src={academy[`platformlist${i}icon`]} alt={`icon${i}`} />
                                        </div>
                                        <div className="icon-box-con">
                                            <h6>{academy[`platformlist${i}Title`]}</h6>
                                            <p>{academy[`platformlist${i}Desc`]}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="col-md-4 d-none d-md-block">
                            <center>
                                <LazyLoadImage src={centerBox} alt="center-box" className='img-cen img-fluid' />
                            </center>
                        </div>

                        <div className="col-md-4">
                            <div className="card-wrap mb-4">
                                {[3, 4].map(i => (
                                    <div key={i} className="icon-box">
                                        <div className="icon">
                                            <LazyLoadImage src={academy[`platformlist${i}icon`]} alt={`icon${i}`} />
                                        </div>
                                        <div className="icon-box-con">
                                            <h6>{academy[`platformlist${i}Title`]}</h6>
                                            <p>{academy[`platformlist${i}Desc`]}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* FAQ */}
            <Faq language={language} />

            {/* CTA SECTION */}
            <section className='cta'>
                <div className="container">
                    <center>
                        <h2
                            className='sec-title block-view'
                            dangerouslySetInnerHTML={{ __html: academy.ctaTitle }}
                        ></h2>
                        <p
                            className="sec-p block-view"
                            dangerouslySetInnerHTML={{ __html: academy.ctadesc }}
                        ></p>

                        {/* ✅ CTA Button */}
                        <button
                            className={`explore-btn cta-btn my-4 py-2 gap-3 block-view ${language === "ar" ? "ar-padding" : "en-padding"
                                } `}
                            onClick={() => setShowModal(true)}
                        >
                            {academy.ctabutton}
                            <LazyLoadImage src={arrow} alt="arrow" className="rt-btn" />
                        </button>
                    </center>
                </div>
            </section>

           

        </>
    );
};

export default Academy;
